import { Component, OnInit } from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {RegisteredUserConfigurationApiService} from '../../../services/api/settings/advanced/users/registered-user-configuration-api.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';

@Component({
  selector: 'advanced-users',
  templateUrl: './advanced-users.component.html',
  styleUrls: ['./advanced-users.component.scss']
})
export class AdvancedUsersComponent implements OnInit {

  usersSettings: any = {};
  canSubmit: boolean;

  constructor(private registeredUsersConfigurationApiService: RegisteredUserConfigurationApiService,
              private userPrivilege: UserPrivilegeService, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.initialization();
  }

  submit(): void {
    this.registeredUsersConfigurationApiService.updateRegisteredUsersConfiguration(this.usersSettings).then(() => {}).catch(() => {});
  }

  initialization(): void {
    this.loaderService.showMainContainer();
    this.registeredUsersConfigurationApiService.getRegisteredUsersConfiguration()
      .then((value) => {
        this.usersSettings = value;
        this.loaderService.hideMainContainer();
      }).catch(() => {
      this.loaderService.hideMainContainer();
    });
  }

}
